/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Hotline_Cta_Label1Inputs */

const vi_sitesettings_home_hotline_cta_label1 = /** @type {(inputs: Sitesettings_Home_Hotline_Cta_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ nút gọi đặt hàng`)
};

/**

* @param {Sitesettings_Home_Hotline_Cta_Label1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_hotline_cta_label1 = /** @type {((inputs?: Sitesettings_Home_Hotline_Cta_Label1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Hotline_Cta_Label1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_hotline_cta_label1(inputs)
});
export { sitesettings_home_hotline_cta_label1 as "siteSettings_home_hotline_cta_label" }